<!--
 * @Author: ‘巴博尔’ 2164119982@qq.com
 * @Date: 2023-11-07 10:44:46
 * @LastEditors: ‘巴博尔’ 2164119982@qq.com
 * @LastEditTime: 2023-11-07 11:02:55
 * @FilePath: \admin_pc\src\views\store-lesson-card\components\expCardVT.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-form
      ref="registerRef"
      :model="createParam"
      :rules="rules"
      label-width="150px"
    >
      <el-form-item label="版本:" prop="userPhone">
        <el-select
          :disabled="childInfo && childInfo.id ? true : false"
          v-model="createParam.lessonsTemplateId"
          placeholder="请选择体验卡类型"
          style="width: 270px"
          @change="changeLessonIdX"
        >
          <el-option
            v-for="item in [
              { label: 'A', value: 2 },
              { label: 'B', value: 1 },
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="版本:" prop="storeLessonsId">
        <el-select
          :disabled="childInfo && childInfo.id ? true : false"
          v-model="createParam.storeLessonsId"
          placeholder="请选择版本"
          @change="changeLessonTemplate"
          style="width: 270px"
        >
          <el-option
            v-for="item in storeLessons"
            :key="item.storeLessonId"
            :label="item.name"
            :value="item.storeLessonId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设置:" prop="statu">
        <el-select
          v-model="createParam.statu"
          placeholder="请选择"
          style="width: 270px"
        >
          <el-option
            v-for="item in [
              { label: '启用', value: 0 },
              { label: '禁用', value: 1 },
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleCreate('registerRef')"
        >保存</el-button
      >
    </div>

    <worker-word
      :key="refreshWord"
      :word-type="wordType"
      :t-data="tData"
      :show="showWordDlg"
      @onWorkerWord="handleWord"
    ></worker-word>
  </div>
</template>

<script>
import {
  createExpCard,
  forbitLessonCard,
  useLessonCard,
} from "@/api/StoreLessonCard";
import { qlLessonTemplate } from "@/api/StoreLesson";
import globaldata from "@/utils/globaldata";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import commonUtils from "@/utils/commonUtils";
import messageUtils from "@/utils/messageUtils";
export default {
  components: {
    WorkerWord,
  },
  props: {
    // storeLessons: Array,
    childInfo: Object,
  },
  data() {
    return {
      storeLessons: [],
      // createParam: {
      //   lessonsTemplateId: '',
      //   storeLessonsId: '',
      //   statu: '',
      //   name: '',
      // },
      createParam: {},
      rules: {
        name: [{ required: true, message: "请输入卡名称", trigger: "blur" }],
        descripe: [
          { required: true, message: "请输入卡描述", trigger: "blur" },
        ],
        storeLessonCardTemplateId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        useType: [
          { required: true, message: "请选择使用类型", trigger: "blur" },
        ],
        optionsValue: [
          { required: true, message: "请选择计费类型", trigger: "blur" },
        ],
        totalClassCount: [
          { required: true, message: "请输入正价课时", trigger: "blur" },
        ],
        valueMoney: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        statu: [{ required: true, message: "请选择启用状态", trigger: "blur" }],
        storeLessonsId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        validDays: [
          { required: true, message: "请选择卡有效时长", trigger: "blur" },
        ],
      },
      refreshWord: "",
      showWordDlg: false,
      tData: null,
      wordType: 0,
    };
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      this.createParam = {
        lessonsTemplateId:
          this.childInfo && this.childInfo.storeLessonCardTemplateId
            ? this.childInfo.storeLessonCardTemplateId
            : "",
        storeLessonsId:
          this.childInfo && this.childInfo.storeLessonId
            ? this.childInfo.storeLessonId
            : "",
        statu:
          this.childInfo && this.childInfo.id ? Number(this.childInfo.statu) : "",
        name: "",
      };
      if (this.childInfo && this.childInfo.storeLessonCardTemplateId) {
        this.changeLessonIdX(this.childInfo.storeLessonCardTemplateId);
      }
    },
    changeLessonTemplate() {
      this.storeLessons.forEach((item) => {
        if (item.storeLessonId == this.createParam.storeLessonsId) {
          this.createParam.name = item.name;
        }
      });
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    changeLessonIdX(e) {
      // console.log(e,'===============')
      // return
      if (!this.childInfo && !this.childInfo.storeLessonCardTemplateId) {
        this.createParam.storeLessonsId = "";
      }
      qlLessonTemplate({
        lessonId: e,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessons = res.data;
        }
      });
    },
    handleWord(wordType, tData) {
      console.log(tData, "tData");
      if (wordType == 1) {
        //禁用
        this.handleForbit(tData);
      } else if (wordType == 2) {
        //启用
        this.handleUse(tData);
      }
    },
    doRefreshWord(show, wordType, tData) {
      this.wordType = wordType;
      this.tData = tData;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = show;
    },
    closeWordDlg() {
      this.wordType = 0;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = false;
    },
    handleForbit(param) {
      forbitLessonCard(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        if (response.code == 20000) {
          this.closeWordDlg();
          messageUtils.successMsg(this, response.message);
          this.$emit("onBtnCreate");
        }
      });
    },
    handleUse(param) {
      useLessonCard(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        if (response.code == 20000) {
          this.closeWordDlg();
          messageUtils.successMsg(this, response.message);
          this.$emit("onBtnCreate");
        }
      });
    },

    handleCreate(registerRef) {
      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          if (this.childInfo && this.childInfo.id) {
            // 有值，走编辑操作
            let param = {
              cardId: this.childInfo.id,
              storeFrontId: globaldata.getAdminStore().storeFrontId,
              adminId: globaldata.getAdminStore().id,
            };
            this.doRefreshWord(true, this.createParam.statu == 0 ? 2 : 1, param);
          } else {
            createExpCard({
              ...this.createParam,
              storeFrontId: globaldata.getAdminStore().storeFrontId,
            }).then((res) => {
              if (res.code == 20000) {
                this.$emit("onBtnCreate");
              }
            });
          }

          //   let param = this.createParam;
          //   param.storeFrontId = globaldata.getAdminStore().storeFrontId;
          //   param.createAdminId = globaldata.getAdminStore().id;
          //   createUserChild(param).then((response) => {
          //     messageUtils.successMsg(this, "创建成功");
          //     this.$emit("onBtnCreate");
          //   });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/store-lesson-card/components/expCardVT.vue